import { queryFirst, loadScript } from 'lilly/domUtil';
const { showQuickview } = require('./quickView/styliticsQuickView').default;
const $body = $('body');
const mainConteinerId = 'stylitics-dynamic-gallery';
const styliticsGallerySettings = queryFirst('#stylitics-gallery-settings')
    .getAttribute('data-stylitics-gallery-settings');
let initInProgress;
const { isMobile } = require('lilly/util');

/**
 * get widget's settings
 * @return {Object|boolean} widget settings
 */
function getSettings() {
    // dont load Stylitics script if current category does not have gallery
    if (!styliticsGallerySettings || !queryFirst('#' + mainConteinerId)) return false;

    let settings;
    try {
        settings = JSON.parse(styliticsGallerySettings);
    } catch (e) {
        return false;
    }

    return settings;
}

/**
 * set demo data if demoMode is enabled
 * @param {Object} settings - widget settings
 * @return {Object} widget settings
 */
function setDemoData(settings) {
    return {
        galleryId: 'demo',
        payload: {
            api: {
                page: 'www.stylitics-demo.com/womens/apparel'
            },
            internal: {
                purchased: ['BP508_NA6445', 'BG654_BL8133', '608066_2661'],
                browsed: ['BP313_EE3740', 'BP313_BK0001', 'BM546_WQ9746', 'BF456_BR6302'],
                sessionId: '1-2-3-4-5'
            }
        },
        demoQuickViewProductId: settings.demoQuickViewProductId
    };
}

/**
 * get data for initialize widget
 * @param {Object} settings - widget settings
 * @return {Object} widget settings
 */
function getRequestData(settings) {
    if (settings.isDemoMode) return setDemoData(settings);

    let host = settings.isTestMode && settings.testHost ? settings.testHost : window.location.hostname;
    return {
        galleryId: settings.galleryId,
        payload: {
            api: {
                page: host + window.location.pathname
            },
            customer: {
                profileIdPath: 'utag_data.sfcc_customer_id'
            },
            analytics: {
                placement: 'gallery'
            },
            responsive: [
                [0, { columns: 1 }],
                [519, { columns: 2 }],
                [698, { columns: 3 }],
                [1280, { columns: 4 }],
                [1536, { columns: 5 }]
            ]
        }
    };
}

/**
 * main function for gallery initialization
 * @param {Object} settings - widget settings
 */
function initializeStyliticsGallery(settings) {
    let requestData = getRequestData(settings);

    // init gallery
    // eslint-disable-next-line
    const galleryWidgetInstance = new StyliticsDynamicGalleriesWidget(
        requestData.galleryId, mainConteinerId, requestData.payload);

    // show QuickView popup if user clicks to shop button
    galleryWidgetInstance.override('click', 'item', function (data) {
        const { item, element } = data;
        if (!item || !element) return;
        let productID = item.remote_id;

        // set test productId if it is testMode
        if (settings.isDemoMode) productID = requestData.demoQuickViewProductId;
        if (!productID) return;

        if (isMobile()) {
            // redirect to the PDP
            window.location.href = settings.pdpUrl + productID;
        } else {
            // show QuickView popup
            showQuickview(element, settings.quickViewUrl + productID, true);
        }

        // send analytics data to track QuickView's click
        galleryWidgetInstance.trackViewItem(productID);
    });

    // analytics event to track of adding item to cart
    $body.on('stylitics:gallery:addItem', function (event, data) {
        if (galleryWidgetInstance && data.pid) {
            const analyticsData = { itemId: data.pid, placement: 'widget' };

            // add price number
            if (data.price) analyticsData.price = data.price.split('$').pop();

            // send to Stylitics
            galleryWidgetInstance.trackAddItemToCart(analyticsData);
        }
    });

    // set initInProgress after Widget was mounted
    galleryWidgetInstance.on('mount', 'outfits', function () {
        initInProgress = false;
    });

    // show gallery widget
    galleryWidgetInstance.start();
}

document.addEventListener('DOMContentLoaded', function () {
    const settings = getSettings();
    if (!settings || !settings.script) return;

    // init widget
    loadScript(settings.script, true).then(function () {
        initInProgress = true;
        initializeStyliticsGallery(settings);

        // event to reinitialization of Stylitics Gallery Widget, if init is not in progress AND block is empty
        $body.on('search:updateProducts', function () {
            if (!initInProgress && settings && $('#' + mainConteinerId).is(':empty')) initializeStyliticsGallery(settings);
        });
    });
});
